import React, { useState, useRef } from 'react';
import emailjs from '@emailjs/browser';

const Popup = ({ message, onClose }) => {
  return (
    <div style={styles.popupContainer}>
      <div style={styles.popup}>
        <p>{message}</p>
        <button onClick={onClose} style={styles.closeButton}>
          Close
        </button>
      </div>
    </div>
  );
};

export const EmailRestAPI = () => {
  const [status, setStatus] = useState(null); // Track form status
  const [showPopup, setShowPopup] = useState(false); // Control popup visibility
  const [popupMessage, setPopupMessage] = useState('');
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
    
    setStatus('sending'); // Set status to "sending"

    const formData = new FormData(form.current);
    for (let [key, value] of formData.entries()) {
      console.log(`${key}: ${value}`);
    }

    
    emailjs
      .sendForm('service_g4sg6yv', 'template_c1vnz2d', form.current, {
        publicKey: 'NjnJnEbcO3czpk5uy',
      })
      .then(
        () => {
          setStatus('success'); // Set status to "success" on success
          setPopupMessage('Your message was sent successfully!');
          setShowPopup(true);

          // Clear form fields after successful submission
          form.current.reset();  // Reset the form using the ref
        },
        (error) => {
          setStatus('error'); // Set status to "error" on failure
          setPopupMessage('There was an error sending your message. Please try again.');
          setShowPopup(true);
        },
      );
  };

  const closePopup = () => {
    setShowPopup(false); // Close popup when the button is clicked
  };

  return (
    <div className='contactFrom'>
      <h1>General Query / Feedback</h1>
      <form ref={form} onSubmit={sendEmail}>
        <label>Full Name</label>
        <input type="text" name="from_name" placeholder="Your Name" required />
        <label>Email</label>
        <input type="email" name="from_email" placeholder="Your Email" required />
        <label>Contact No.</label>
        <input type="tel" name="from_number" placeholder="Your Contact Number" required />
        <label>Your Message</label>
        <textarea name="message" placeholder="Your Message" required></textarea>
        <input className='contactbtn' type="submit" value="Send" />
      </form>

      {showPopup && <Popup message={popupMessage} onClose={closePopup} />}
    </div>
  );
};

// Simple styles for the popup
const styles = {
  popupContainer: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    zIndex: 1000,
  },
  popup: {
    backgroundColor: 'white',
    padding: '20px',
    borderRadius: '8px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
    textAlign: 'center',
    maxWidth: '400px',
    width: '100%',
  },
  closeButton: {
    marginTop: '10px',
    padding: '10px 20px',
    backgroundColor: '#007BFF',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
  },
};
